import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { type Block } from "@shared/config/auth-config";
import { Fields } from "remult";
import { OTPEntityConfig } from "./config";
import { OTPFilters } from "./filters";
import { OTPMethods } from "./methods";

@HyperEntity<OTP>("otp", OTPEntityConfig)
export class OTP extends extender(OTPFilters, OTPMethods) {
  @Fields.uuid({ allowApiUpdate: false })
  id = "";

  @Fields.string({
    dbName: "phone_number",
    includeInApi: true,
  })
  phoneNumber = "";

  @Fields.number({ includeInApi: false })
  attempts = 0; //5 - short block, 10 - long block, 15 - day block

  @Fields.string()
  blocked: Block = "NO_BLOCK";

  @Fields.date({ dbName: "user_blocked_at", includeInApi: true })
  userBlockedAt: Date = new Date();

  @Fields.string({ dbName: "code_hash", includeInApi: false })
  codeHash?: string;

  @Fields.string({ dbName: "registration_token_hash", includeInApi: false })
  registrationTokenHash?: string;

  @Fields.boolean({ dbName: "is_admin", includeInApi: false })
  isManager = false;

  @Fields.boolean({
    dbName: "is_validated",
  })
  isValidated = false;

  @Fields.date({
    dbName: "validate_at",
  })
  validateAt?: Date;

  @Fields.date({ dbName: "code_sent_at", includeInApi: true })
  codeSentAt: Date = new Date();

  @Fields.updatedAt({ dbName: "updated_at", includeInApi: false })
  updatedAt = new Date();

  @Fields.createdAt({ dbName: "created_at", includeInApi: false })
  createdAt = new Date();
}
